<template>
	<b-overlay :show="showOverlay" rounded="sm">
		<b-card class="sa-card sa-page-dashboard-card-body-chart" style="height: 100%" :header="chartParams.title" header-tag="header" footer-tag="footer" title="">
			<template #header>
				<div style="display: flex">
					<span style="flex: 1">{{ chartParams.title }}</span>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickZoomChart(chartParams)">
						<i class="fas fa-search-plus"></i>
					</b-button>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickViewData(chartParams)">
						<i class="fas fa-database"></i>
					</b-button>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickViewDetails()">
						<i class="fas fa-table"></i>
					</b-button>
				</div>
			</template>
			<b-card-body>
				<div v-if="chartParams.type === 'graphic'" class="sa-page-dashboard-body-graphic" style="height: 300px">
					<generic-chart-component :marginLeft="marginLeft" :legendVisible="legendVisible" :horizontalBar="horizontalDirection" xAxisType="value" :chartData="chartData" :chartType="chartParams.graphicType"></generic-chart-component>
				</div>
				<div v-else>
					<p>{{ chartParams }}</p>
					<b-card-text class="text-right sa-dashboard-data-text">{{ chartParams.value }}</b-card-text>
				</div>
			</b-card-body>
			<data-analysis-modal-view-data-component ref="mdlDataAnalysisModalViewDataComponent"></data-analysis-modal-view-data-component>
			<data-analysis-chart-view-modal-component ref="mdlDataAnalysisChartViewModalComponent"></data-analysis-chart-view-modal-component>
			<data-analysis-dashboard-pivot-edit-modal-component ref="mdlDataAnalysisDashboardPivotEditModalComponent" @updatePivotParams="onUpdatePivotParams"></data-analysis-dashboard-pivot-edit-modal-component>
		</b-card>
	</b-overlay>
</template>

<script>
import GenericChartComponent from "../../utility/components/GenericChartComponent.vue";
import DataAnalysisModalViewDataComponent from "./DataAnalysisModalViewDataComponent.vue";
import DataAnalysisChartViewModalComponent from "./DataAnalysisChartViewModalComponent.vue";
import DataAnalysisDashboardPivotEditModalComponent from "./DataAnalysisDashboardPivotEditModalComponent.vue";
import DataAnalysisChartMixin from "../mixins/DataAnalysisChartMixin";
export default {
	props: {
		chartParams: { type: Object },
	},
	mixins: [DataAnalysisChartMixin],
	components: { GenericChartComponent, DataAnalysisModalViewDataComponent, DataAnalysisChartViewModalComponent, DataAnalysisDashboardPivotEditModalComponent },
	computed: {
		marginLeft() {
			return this.chartParams.marginLeft;
		},
		legendVisible() {
			return this.chartParams.legendVisible;
		},
		horizontalDirection() {
			return this.chartParams.horizontalDirection;
		},
	},
	mounted() {
		this.$emit("beforeLoadData", this.chartParams);
		if (this.chartParams.idQuery) {
			this.setChartData();
		} else {
			this.showOverlay = false;
		}
	},
	data() {
		return {
			chartData: { titolo: "", unitaMisura: "", xAxis: [{ type: "value" }], series: [] },
			pathResourceData: "/dataanalysisdatabaseinfo/eseguigraphicquery",
			showOverlay: true,
			queryResult: [],
			configChart: { fileds: [], dimension: "", xvalue: "", filters: "" },
		};
	},
	methods: {
		// onClickEditDetails() {
		// 	console.log(this.chartParams);
		// 	this.$refs.mdlDataAnalysisDashboardPivotEditModalComponent.show(this.chartParams);
		// },
		onClickViewDetails() {
			let me = this;
			let sessionElement = { idDashboard: me.id, bodyElement: me.chartParams };
			sessionStorage.setItem("sessionElement", JSON.stringify(sessionElement));
			me.$router.push("/dataanalysisdashboards/view/pivot/" + me.chartParams.id);
		},
	},
};
</script>

<style></style>
